/**
 * 设备指纹（canvas、字体、WebGL、时区、插件等 30+ 维度）
行为数据（鼠标轨迹、按键间隔、页面停留）
环境风险（DevTools 打开、自动化工具特征、代理 IP）
加密签名（RSA + AES 把数据加密成 spartaHeader，防止前端篡改）
 */

import PaWebJs from 'libs/pawebjs.simplified.min';

let spartaHeader;
try {
  spartaHeader = new PaWebJs().get();
} catch (error) {
  //ignore
}

export default spartaHeader;
